<div class="warning-banner">
    <slot name="text"/>

    <slot/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.media-queries.less";

    .warning-banner {
        width: 100%;
        background-color: #FFF1E3;
        color: var(--warning-orange);
        border: 1px solid var(--warning-orange);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: @spacing-m @spacing-l;
        gap: @spacing-xl;
        border-radius: @border-radius-default;

        @media (max-width: @screen-xs-max) {
            flex-direction: column;
            padding: @spacing-s @spacing-sm;
            align-items: unset;
        }
    }
</style>